import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_END_POINTS } from '../constant/api.constant'
@Injectable({
  providedIn: 'root'
})
export class WalletService {

  constructor(
    private _http: HttpClient
  ) { }

  public claimReward(id): Observable<any> {
    let data = {}
    return this._http.put(`${API_END_POINTS.WALLET.rewards}/${id}`, data)
  }

  public getRewardAmount(): Observable<any> {
    return this._http.get(`${API_END_POINTS.WALLET.rewards}/amount`)
  }
  public getPayoutAmount(): Observable<any> {
    return this._http.get(`${API_END_POINTS.WALLET.payout}`)
  }

  public allRewards(query): Observable<any> {
    return this._http.get(`${API_END_POINTS.WALLET.rewards}?${query}`)
  }

  public allReferrals(): Observable<any> {
    return this._http.get(API_END_POINTS.WALLET.referral)
  }

  public getReferralAmount(activity): Observable<any> {
    return this._http.get(`${API_END_POINTS.WALLET.referral_amt}?scope=investor&activities=${activity}`)
  }

  public rewardToBank(data: any): Observable<any> {
    return this._http.post(API_END_POINTS.RAZORPAY.bank_account, data)
  }

  public transferPayout(data:any): Observable<any> {
    return this._http.post(`${API_END_POINTS.WALLET.payout}`, data)
  }

}